<template>
  <div
    class="decorator-text"
    :style="{
      '--hover-cursor': hoverStyle?.cursor || 'auto',
      '--hover-bgColor': hoverStyle?.backgroundColor || customStyle.backgroundColor || 'transparent',
      ...position,
      ...customStyle,
      display: visible ? defaultDisplay : 'none',
    }"
    @click="handleClick"
  >
    {{ text }}
  </div>
</template>

<script lang="ts" setup>
import { inject } from "vue"
import useToggle from "@p-v/hooks/useToggle"

const router = inject("router") as any
const getScene = inject("getScene") as () => {
  scene: string
}

interface DecorateTextProps {
  id: string
  text: string
  position?: any
  customStyle?: any
  hoverStyle?: any
  target?: string
  withScene?: boolean
  clickObj?: {
    fun: string
    params?: {
      [key: string]: any
    }
    [key: string]: any
  }
}

const props = withDefaults(defineProps<DecorateTextProps>(), {
  text: "",
})

const { visible, show, hide, changeVisible } = useToggle(!(props.customStyle?.display === "none"))

function handleClick() {
  if (props.target) {
    redirect()
  } else if (props.clickObj) {
    handleCustomClick()
  }
}

const handleCustomClick = () => {
  // clickFunction函数化
  if (!props.clickObj) {
    return
  }
  console.log(...Object.keys(props.clickObj.params || {}), props.clickObj.fun)
  const fn = new Function(...Object.keys(props.clickObj.params || {}), props.clickObj.fun)
  try {
    console.log(...Object.values(props.clickObj.params || {}))
    fn(...Object.values(props.clickObj.params || {}))
  } catch (error) {
    console.error("Error executing click function:", error)
  }
}

function redirect() {
  // 判断props.target是否为网址
  if (!props.target) {
    return
  }
  if (props.target.startsWith("http")) {
    let url = props.target
    if (props.withScene) {
      const { scene } = getScene()
      // 判断 url 是否有？
      if (url.includes("?")) {
        url += `&scene=${scene}`
      } else {
        url += `?scene=${scene}`
      }
    }
    window.open(url)
    return
  }
  router.push(props.target)
}

// 避免display样式被覆盖
const defaultDisplay = props.customStyle?.display || "inline-block"

defineExpose({
  show,
  hide,
  toggle: () => changeVisible(),
  goto: redirect,
})
</script>

<style lang="scss" scoped>
.decorator-text {
  position: absolute;
}

.decorator-text:hover {
  cursor: var(--hover-cursor);
  background-color: var(--hover-bgColor) !important;
  border-color: var(--hover-borderColor) !important;
}
</style>
